/// <reference types="user-agent-data-types" />
import { IS_PRODUCTION } from 'src/consts/index';

/**
 * Detects if the browser is the Playwright browser that hydra tests use.
 * This will only be set to true in lower envs, otherwise will always be false.

 * @returns boolean
 */
/* https://stackoverflow.com/a/68428992 */
export function isHydra(): boolean {
  if (IS_PRODUCTION) {
    return false;
  }
  if (
    typeof window === 'undefined' ||
    typeof window.navigator === 'undefined' ||
    typeof window.navigator.userAgentData === 'undefined' ||
    typeof window.navigator.userAgent === 'undefined'
  ) {
    return false;
  }
  const vendors = window.navigator.userAgentData.brands;
  const userAgent = window.navigator.userAgent;
  if (vendors.filter(e => e.brand === 'Google Chrome').length > 0) {
    return false;
  } else if (vendors.filter(e => e.brand === 'Chromium').length > 0) {
    return true;
  } else if (userAgent.includes('HeadlessChrome')) {
    return true;
  } else {
    return false;
  }
}
